import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { EXRLoader } from 'three/examples/jsm/Addons.js';
import gsap from 'gsap';

export let gltf, obj, animations;

const objetList = [
    'geo_ani01',
    'geo_ani02',
    'geo_ani03_constraint',
    'geo_ani04',
    'geo_ani05_a', 'geo_ani05_b', 'geo_ani05_c',
    'geo_ani06_shake',
    'geo_ani07',
    'geo_ani08',
    'geo_ani09_transform', 'geo_ani09_transform001',
    'geo_ani10',
    'geo_ani11', 'geo_ani11_a', 'geo_ani11_b', 'geo_ani11_c', 'geo_ani11_d',
    'geo_ani12'
];

export const loadModel = async (
    scene,
    group,
    loadingManager,
    setLoading,
    loadingRef,
    loadingRateRef,
    pmremGenerator
) => {
    let exrCubeRenderTarget;
    // console.log("EXR Load..");

    return new Promise((resolve, reject) => {
        new EXRLoader().load(
            `${process.env.PUBLIC_URL}/data/hdri/iw_hdri_10.exr`,
            async (texture) => { // ✅ async 추가
                exrCubeRenderTarget = pmremGenerator.fromEquirectangular(texture);

                try {
                    const setupModel = await loadGLTF(
                        scene,
                        group,
                        loadingManager,
                        exrCubeRenderTarget,
                        setLoading,
                        loadingRef,
                        loadingRateRef
                    );
                    texture.dispose();
                    resolve(setupModel); // ✅ 모델 로드 완료 후 반환
                } catch (error) {
                    console.error("Error loading GLTF:", error);
                    reject(error);
                }
            }
        );
    });
};

export const loadGLTF = (
    scene,
    group,
    loadingManager,
    exrCubeRenderTarget,
    setLoading,
    loadingRef,
    loadingRateRef
) => {
    return new Promise((resolve, reject) => {
        const gltfLoader = new GLTFLoader(loadingManager);
        const dracoLoader = new DRACOLoader();

        dracoLoader.setDecoderPath(`${process.env.PUBLIC_URL}/data/draco/`);
        gltfLoader.setDRACOLoader(dracoLoader);

        gltfLoader.load(
            // './data/model/World_f.glb',
            `${process.env.PUBLIC_URL}/data/model/World.glb`,
            // `${process.env.PUBLIC_URL}/data/model/World_avif.glb`,
            // `${process.env.PUBLIC_URL}/data/model/World DRACO avif.glb`,
            (gltfFile) => {
                gltf = gltfFile;
                const model = gltfFile.scene;
                animations = gltfFile.animations;
                // mixer = new THREE.AnimationMixer(model);

                model.position.set(0, 0, 0);
                // model.scale.set(5, 5, 5);

                model.traverse(child => {
                    if (child.isMesh) {
                        child.material.envMap = exrCubeRenderTarget.texture;
                        child.material.envMapIntensity = 1.2;
                        child.material.needsUpdate = true;
                        // child.castShadow = true;
                        child.material.shadowIntensity = 20;
                        child.receiveShadow = true;

                    }

                    if (child.name === 'geo_ani12') {
                        const clone = child.clone(true);
                        clone.traverse(_child => {
                            if (_child.isMesh && _child.material) {
                                // _child.material = _child.material.clone();
                            }
                        })
                        clone.scale.set(0.015, 0.015, 0.015);
                        clone.name = 'objet';
                        group.add(clone);
                    }

                    if (objetList.includes(child.name)) {
                        child.children.forEach(c => {
                            c.castShadow = true;
                            c.receiveShadow = true;
                        });
                    }

                    if (child.name === 'floor') {
                        child.material.color = new THREE.Color().setHex(0xE1E9F6);
                        child.needsUpdate = true;
                    }
                    if (child.name === 'glass_A') {
                        child.material.emissive = new THREE.Color().setHex(0x000000);
                    }
                    if (child.name === 's04_balloon') {
                        child.castShadow = true;
                    }
                    if (child.name === 's10_bezier_legA') {
                        child.visible = false;
                    }
                    if (child.name === 's08_bal') {
                        child.visible = false;
                    }
                    if (child.name === 's01_geo') {
                        child.traverse(_child => {
                            if (_child.isMesh) _child.material = _child.material.clone();
                        })
                    }

                    if (child.name === 'start_coin') {
                        child.rotation.set(0, 0, 0);
                        gsap.to(child.rotation, {
                            z: '+=6.283',
                            duration: 2,
                            repeat: -1,
                            ease: 'none'
                        });
                        child.position.set(-0.025, 0.45, .5);
                        child.rotation.set(-Math.PI / 2, Math.PI, 0);
                        child.scale.set(0.05, 0.038, 0.05);
                        child.castShadow = true;
                        child.receiveShadow = true;

                        child.visible = true;
                    }
                    if (child.name === 'start_coin_ani') {
                        child.visible = false;
                    }
                    if (child.name.includes('sb_light')) {
                        child.material.opacity = 0;
                    }
                    if (child.name.includes('hitbox')) {
                        child.material.transparent = true;
                        child.material.opacity = 0;
                    }

                    if (child.name === 's02_screen') {
                        new THREE.TextureLoader().load(
                            `${process.env.PUBLIC_URL}/data/textures/screen/mini.png`,
                            (texture) => {
                                texture.flipY = false;
                                child.material.map = texture;
                                child.material.color = new THREE.Color().setHex(0xffffff);
                                child.material.needsUpdate = true;
                            }
                        )
                    }
                    if (child.name === 's07_spray_red' ||
                        child.name === 's07_spray_green' ||
                        child.name === 's07_spray_blue'
                    ) {
                        // child.visible = false;
                        child.material.opacity = true;
                        child.material.opacity = 0;
                    }
                    if (child.name === 'end_light' || child.name === 's09_light') {
                        child.material.opacity = true;
                        child.material.opacity = 0;
                        child.material.blending = THREE.AdditiveBlending;
                    }

                });

                // const hand = model.getObjectByName('s10_hand');

                // hand.traverse(child => {
                //     if (!child.name.startsWith('s10_hand_')) {
                //         child.name = `s10_hand_${child.name}`;
                //     }
                // })

                group.add(model);
                obj = model;

                // ✅ 모델이 완전히 로드된 후 resolve 호출
                resolve({ gltf, obj, animations });

                //!TEST
                // console.log(dumpObject(scene).join('\n'));
            },
            (xhr) => {
                const loadedRate = (xhr.loaded / 45496504) * 100;
                setLoading(loadingRef, loadingRateRef, loadedRate);
                // console.log(xhr.loaded);
            },
            (error) => {
                console.error("GLTF Load Error:", error);
                reject(error);
            }
        );
    });
};

export const BoxMesh = (group) => {
    const geometry = new THREE.BoxGeometry(0.1, 0.1, 0.1);
    const material = new THREE.MeshStandardMaterial({
        color: new THREE.Color().setHex(0xff0000)
    });
    const mesh = new THREE.Mesh(geometry, material);

    group.add(mesh);
    mesh.castShadow = true;
    mesh.receiveShadow = true;

    return mesh;
}

const dumpObject = (obj, lines = [], isLast = true, prefix = '') => {
    const localPrefix = isLast ? '└─' : '├─';
    lines.push(`${prefix}${prefix ? localPrefix : ''}${obj.name || '*no-name*'} [${obj.type}]`);
    const newPrefix = prefix + (isLast ? '  ' : '│ ');
    const lastNdx = obj.children.length - 1;
    obj.children.forEach((child, ndx) => {
        const isLast = ndx === lastNdx;
        dumpObject(child, lines, isLast, newPrefix);
    });
    return lines;
}

export const RotateModelOnMouseMove = (e, group, mapRange) => {
    const mouseX = (e.clientX / window.innerWidth) * 2 - 1; // -1 ~ 1
    const mouseY = -(e.clientY / window.innerHeight) * 2 + 1; // -1 ~ 1

    if (group) {
        // 회전 범위 설정
        const rotationXMin = -0.05;
        const rotationXMax = 0.0125;
        const rotationYMin = -0.025;
        const rotationYMax = 0.025;

        // 마우스 좌표를 회전 범위로 매핑
        const targetRotationX = mapRange(mouseY, -1, 1, rotationXMin, rotationXMax);
        const targetRotationY = mapRange(mouseX, -1, 1, rotationYMin, rotationYMax);

        // 부드러운 회전 적용
        group.rotation.x = THREE.MathUtils.lerp(group.rotation.x, targetRotationX, 0.1);
        group.rotation.y = THREE.MathUtils.lerp(group.rotation.y, -targetRotationY, 0.1);
        // group.rotation.z = THREE.MathUtils.lerp(group.rotation.z, targetRotationX, 0.1);
        // console.log(group.rotation);

    }
};
